import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Badge } from '@/components/ui/Badge';
import { Card } from '@/components/ui/Card';

export function AccountPageHeader({
  title,
  accountName,
  profileId,
}: {
  title: string;
  accountName: string | null;
  profileId: string;
}) {
  return (
    <Card className="flex flex-col gap-4 p-6 md:flex-row md:items-center md:justify-between">
      <div className="flex items-start gap-4 min-w-0">
        <Link
          to="/accounts"
          className="inline-flex shrink-0 items-center justify-center gap-1.5 rounded-pill px-3 py-1.5 text-xs font-semibold text-foreground-muted transition-colors hover:bg-surface-muted hover:text-foreground mt-0.5"
          aria-label="Back to accounts"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <div className="min-w-0">
          <h1 className="text-headline-lg font-semibold text-foreground">{title}</h1>
          <div className="mt-1 flex flex-wrap items-center gap-2">
            {accountName ? (
              <span className="text-body-md text-foreground-muted">Account: {accountName}</span>
            ) : null}
            <Badge variant="neutral" className="normal-case tracking-normal font-medium">
              Amazon
            </Badge>
            <span className="font-mono text-body-sm text-foreground-muted border-l border-border pl-2 ml-1">
              {profileId}
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
}
